<template>
  <div>
    <div>
      <div class="cartheader" >
        <div class="bg" :style="{width:'100%',height:'100%'}">
          <img v-if="cartList.length==0" src="../../../assets/images/shopcart1.jpg" />
        </div>
        <div class="hh" style="background-color:rgb(190,216,119)">
          <div class="hhmain">
            <span>购物车</span>
            <span class="ff" @click="editaddress">{{addressData?'修改默认地址':'创建默认地址'}}</span>
            <span
              @click="
                () => {
                  if (manage == 0) {
                    manage = 1;
                  } else {
                    manage = 0;
                  }
                }
              "
              >{{ manage == 0 ? "管理" : "完成" }}</span
            >
          </div>
          <div class="hhff">
            <span>共{{ totalnum }}件宝贝</span>
            <span v-if="addressData"
              >收货地址:{{
                addressData.receiverState +
                addressData.receiverCity +
                addressData.receiverDistrict +
                addressData.receiverAddress
              }}</span
            >
          </div>
        </div>
      </div>
      <div class="cartinfol">
        <van-checkbox-group
          class="card-goods"
          ref="checkboxGroup"
          v-model="checkedGoods"
          v-if="cartList"
        >
          <div class="cartmain" v-for="(item, index) in cartList" :key="index">
            <div class="cartmainbg">
              <div class="mainlist">
                <van-swipe-cell>
                  <div class="maininfo">
                    <div class="infock">
                      <van-checkbox
                        :name="item.id"
                        icon-size="16px"
                      ></van-checkbox>
                    </div>
                    <div class="infoimg" @click="godetail(item)">
                      <img :src="$baseurl + item.imageURL" />
                    </div>
                    <div class="infodetail">
                      <div class="tit van-multi-ellipsis--l2">
                        {{ item.title }}
                      </div>
                     <div v-if="item.isSeaProduct" :style="{color:$abctheme.basecolor}">
                          【海外产品】
                      </div>
                       <div v-if="item.stockNum!=undefined">
                          库存:{{item.stockNum}}
                      </div>
                      <div>
                        <span class="sz">{{ item.desc }}</span>
                      </div>
                      <div class="infofooter">
                        <span class="fh"
                          >{{item.productInfo.isIntegral?'积分':'￥'}}<span class="price">{{ item.price }}</span></span
                        >
                        <div class="right">
                          <van-stepper v-model="item.quantity" min="1" :max="item.stockNum" />
                          <!-- <span @click="mm(item)">-</span>
                          <div class="ipt">
                            <input
                              min="1"
                              max="item.stockNum"
                              type="tel"
                              v-model="item.quantity"
                              @change="changenum(item)"
                            />
                          </div>
                          <span @click="add(item)">+</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <template #right>
                    <van-button
                      square
                      text="删除"
                      @click="delgood(item, index)"
                      type="danger"
                      class="delete-button"
                    />
                  </template>
                </van-swipe-cell>
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </div>
    </div>

    <van-submit-bar
      :price="totalPrice"
      :button-type="manage == 0 ? 'danger' : 'warning'"
      :disabled="!checkedGoods.length"
      :button-text="submitBarText"
      @submit="onSubmit"
    >
      <template slot>
        <van-checkbox v-model="checkedAll" @click="clickcheclall"
          >全选</van-checkbox
        >
      </template>
    </van-submit-bar>
    <retailfooter></retailfooter>
  </div>
</template>

<script>
import request from "@/config/ajax";
import Util from "@/config/Util";
import eventBus from '@/config/eventbus';
//import appconst from "../../config/appconst";
export default {
  data() {
    return {
      checkedAll: false,
      checkedGoods: [],
      cartList: undefined,
      monOffSkus: undefined,
      oldcartList: undefined,
      addressData: undefined,
      manage: 0,
    };
  },
  computed: {
    submitBarText() {
      if (this.manage == 1) {
        return "删除";
      }
      const count = this.checkedGoods.length;
      return "结算" + (count ? `(${count})` : "");
    },
    totalnum() {
      if (this.cartList) {
        return this.cartList.reduce((total, item) => {
          return total + item.quantity;
        }, 0);
      } else {
        return 0;
      }
    },
    totalPrice() {
      if (this.cartList) {
        return (
          this.cartList.reduce((total, item) => {
            var cartonSize = item.cartonSize == undefined ? 1 : item.cartonSize;
            return (
              total +
              (this.checkedGoods.indexOf(item.id) !== -1
                ? parseFloat(item.price * item.quantity * cartonSize)
                : 0)
            );
          }, 0) * 100
        );
      } else {
        return 0;
      }
    },
  },
  watch: {
    checkedGoods(newvalue) {
      if (this.cartList) {
        if (this.cartList.length > 0) {
          if (newvalue.length == this.cartList.length) {
            this.checkedAll = true;
          } else {
            this.checkedAll = false;
          }
        } else {
          this.checkedAll = false;
        }
      }
    },
    cartList(newvalue, oldvalue) {
      console.log("监听打印修改:", oldvalue);
    },
  },
  created() {
   
    // eventBus.$on('changeaddress', (data)=> {
    //     //console.log('返回触发数据:',data);
    //     //赋值给首页的附近医院数据模型
    //     console.log("打印数据",data)
    //     isload=false;
    //     this.checkaddress(data);
    // });
    //没有登陆 让他去登录
    if (!Util.abp.session.userId) {
      this.$router.push({
        path: "/login/password",
      });
    } else {
      setTimeout(()=>{
        this.initWx();
      },200)
      this.getmyAddress();
      this.loadcartdata();
    }
    
  },
  methods: {
    getmyAddress() {
      request
        .post("/api/services/app/PhoneUser/QueryDefaultAddress")
        .then((x) => {
          this.addressData = x.result;
        });
    },
     //加载地址
    checkaddress(item) {
        this.addressData = item;
    },
    editaddress(){
      this.$router.push({
          path: '/user/address',
          query: {
              sourece: 0
          }
      });
      //this.$router.push({url:'/user/address?sourece=1'});
    },
    loadcartdata() {
      request.post("/api/services/app/PhoneCart/QueryUserCart").then((x) => {
        this.cartList = x.result.cartList;
        this.oldcartList = JSON.parse(JSON.stringify(x.result.cartList));
        this.monOffSkus = x.result.monOffSkus || [];
      });
    },
    mm(item) {
      let ids = [];
      let list = JSON.parse(JSON.stringify(this.cartList));
      let row = item;
      let id = row.sku;
      let cartonSize = row.cartonSize;
      let quantity = row.quantity - 1;
      if (quantity < 0) {
        this.$toast("数量不能小于1个");
        return;
      }
      ids.push(id);
      let iddto = {
        skuList: ids,
      };

      list.forEach((x) => {
        if (x.sku == id && x.cartonSize == cartonSize) {
          x.quantity = quantity;
        }
      });
      console.log(this.cartList);
      let reqInput = {};
      reqInput.OperatorType = 0;
      reqInput.OperatorSku = id;
      reqInput.cartonSize = cartonSize;
      reqInput.Carts = list;

      this.$toast.loading({
        forbidClick: true,
      });
      //这里有问题 后续再处理 两边的赋值数据竟然一致 不限制变化数量的情况下不会有问题
      request
        .post("/api/services/app/PhoneCart/CartChange", reqInput)
        .then((x) => {
          this.cartList = list;
          this.oldcartList = JSON.parse(JSON.stringify(this.cartList));
        })
        .catch(() => {
          this.cartList = JSON.parse(JSON.stringify(this.oldcartList));
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    add(item) {
      let ids = [];
      let list = JSON.parse(JSON.stringify(this.cartList));
      let row = item;
      let id = row.sku;
      let cartonSize = row.cartonSize;
      let quantity = row.quantity + 1;
      ids.push(id);
      let iddto = {
        skuList: ids,
      };
      list.forEach((x) => {
        if (x.sku == id && x.cartonSize == cartonSize) {
          x.quantity = quantity;
        }
      });
      let reqInput = {};
      reqInput.OperatorType = 0;
      reqInput.OperatorSku = id;
      reqInput.cartonSize = cartonSize;
      reqInput.Carts = list;
      this.$toast.loading({
        forbidClick: true,
      });
      //这里有问题 后续再处理 两边的赋值数据竟然一致 不限制变化数量的情况下不会有问题
      request
        .post("/api/services/app/PhoneCart/CartChange", reqInput)
        .then((x) => {
          this.cartList = list;
          this.oldcartList = JSON.parse(JSON.stringify(this.cartList));
        })
        .catch(() => {
          this.cartList = JSON.parse(JSON.stringify(this.oldcartList));
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    changenum(item) {
      let ids = [];
      let list = this.cartList;
      let row = item;
      let id = row.sku;
      let cartonSize = row.cartonSize;
      let quantity = row.quantity;
      console.log(quantity);
      if (!quantity || quantity < 1) {
        this.cartList = this.oldcartList;
        this.$toast("数量不能小于1个");
        return;
      }
      ids.push(id);
      let iddto = {
        skuList: ids,
      };

      let reqInput = {};
      reqInput.OperatorType = 0;
      reqInput.OperatorSku = id;
      reqInput.cartonSize = cartonSize;
      reqInput.Carts = this.cartList;
      this.$toast.loading({
        forbidClick: true,
      });
      //这里有问题 后续再处理 两边的赋值数据竟然一致 不限制变化数量的情况下不会有问题
      request
        .post("/api/services/app/PhoneCart/CartChange", reqInput)
        .then((x) => {
          this.oldcartList = this.cartList;
        })
        .catch(() => {
          this.cartList = JSON.parse(JSON.stringify(this.oldcartList));
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    delgood(item, index) {
      let ids = [];
      let list = JSON.parse(JSON.stringify(this.cartList));
      let row = list[index];
      let id = row.sku;
      let cartonSize = row.cartonSize;
      ids.push(id);
      let iddto = {
        skuList: ids,
      };
      let reqInput = {};
      reqInput.OperatorType = 1;
      reqInput.OperatorSku = id;
      reqInput.cartonSize = cartonSize;
      reqInput.Carts = this.cartList;
      this.$toast.loading({
        forbidClick: true,
      });
      request
        .post("/api/services/app/PhoneCart/CartChange", reqInput)
        .then((x) => {
          var cc = this.cartList.filter(
            (x) => !(x.sku == id && x.cartonSize == cartonSize)
          );
          this.cartList = cc;
          var ids = this.cartList.map((x) => {
            return x.id;
          });
          this.checkedGoods = this.checkedGoods.filter((x) => ids.includes(x));
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    batchDel() {
      if (this.checkedGoods.length > 0) {
        let delcarts = this.cartList.filter((x) =>
          this.checkedGoods.includes(x.id)
        );
        let req = {
          skuList: [],
        };
        delcarts.map((x) => {
          req.skuList.push({ sku: x.sku, cartonSize: x.cartonSize });
        });
        this.ajax.post("/api/services/app/PhoneCart/CartDel", req).then((x) => {
             this.checkedGoods=[];
          this.loadcartdata();
        });
      }
    },
    onSubmit() {
        if(this.manage==1){
            this.batchDel();
            return;
        }
      //提交订单过去
      //找出被选中的购物车
      //判断一下 只能计算一种商品类型

      var goodlist = this.cartList.filter((x) =>
        this.checkedGoods.includes(x.id)
      );
      var productType = goodlist[0].productType;

      if(goodlist.filter(x=>x.isSeaProduct).length>0&&goodlist.filter(x=>!x.isSeaProduct).length>0)
      {
          this.$toast("海外产品产品和非海外产品产品不能同时结算");
          return;
      }
      // if(goodlist.filter(x=>x.productType==productType).length!=goodlist.length)
      // {
      //     this.$toast("大货和物料不能同时结算");
      //     return;
      // }retailship
        localStorage.setItem("createorderinfo", JSON.stringify(goodlist));
        let page={}
        page.skus=[];
        goodlist.forEach(x => {
                  page.skus.push({
                      sku: x.sku,
                      num: x.quantity,
                      cartonSize: x.cartonSize
                  })
              })
        this.ajax.post('/api/services/app/PhoneTrade/IsBuyer',page).then(x=>{
        localStorage.setItem("createorderinfo",JSON.stringify(goodlist));
              //params:{
              //   name:'nameValue',
              //   code:10011
              //}

            this.$router.push({
                name: "retailship",
                query: {
                  createType: 0,
                },
              });
              //createType=0 //代表购物车
        }).catch(x=>
        {
            this.loadcartdata();
        });
      
    },
    clickcheclall() {
      if (this.checkedAll) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    godetail(item)
    {
        
        var productsku=item.productInfo.productSku;
        this.$router.push({path:'/product/'+productsku});
    },
    initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
          var h5info = y.result;
          var wx = window.wx;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: h5info.appid, // 必填，公众号的唯一标识
            timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
            nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
            signature: h5info.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareWeibo",
              "scanQRCode",
            ], // 必填，需要使用的JS接口列表
          });
           let link =
            "http://" +
            location.host ;
wx.ready(() => {
            wx.updateAppMessageShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              desc: this.abp.systemconfig.shareDesc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
            wx.updateTimelineShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
          });
          wx.error(function (res) {
            //alert(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.van-submit-bar {
  margin-bottom: 49px;
}

.bg {
  position: absolute;
  z-index: -1;
  top: -50px;
}

.bg img {
  width: 100%;
}

.hh {
  padding: 10px 20px 10px 20px;
  color: white;
}

.hhmain {
  position: relative;
  margin-bottom: 10px;
}

.hhmain span:first-child {
  font-size: 28px;
}

.hhmain span:last-child {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 16px;
}

.hhff {
  font-size: 12px;
  color: black;
}

.hhff span:first-child {
  margin-right: 20px;
}

.cartmain {
  padding: 10px 10px 0px 10px;
}

.cartmainbg {
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
}

.maininfo {
  position: relative;
  padding-left: 120px;
}

.infock {
  position: absolute;
  left: 0;
  transform: translate(0, -50%);
  top: 50%;
}

.infoimg {
  position: absolute;
  left: 20px;
  width: 95px;
  height: 95px;
  transform: translate(0, -50%);
  top: 50%;
}

.infoimg img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.infodetail {
  position: relative;
  min-height: 100px;
}

.infodetail .tit {
  font-size: 13px;
  margin-bottom: 5px;
}

.infodetail .sz {
  font-size: 11px;
  background-color: #eee;
  color: #a7a7a7;
}

.infofooter {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.infodetail .fh {
  font-size: 14px;
  color: #ff5c2e;
  font-weight: 500;
}

.infodetail .price {
  font-size: 20px;
}

.infodetail .right {
  position: absolute;
  right: 10px;
  top: -3px;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
}

.infodetail .right span:first-child {
  padding: 1px 8px;
  border-radius: 9999px 0px 0px 9999px;
  border: 1px solid #ccc;
  color: #868484;
  float: left;
}

.infodetail .right span:last-child {
  padding: 1px 8px;
  border-radius: 0px 9999px 9999px 0px;
  border: 1px solid #ccc;
  color: #868484;
  float: right;
}

.infodetail .right .ipt {
  display: inline-block;
}

.infodetail .right .ipt input {
  width: 20px;
  padding: 1px 5px;
  border: 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: center;
}

.delete-button {
  height: 100%;
}

.cartinfol {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  top: 90px;
  overflow: auto;
}

.cartinfol .cartmain:last-child {
  margin-bottom: 60px;
}
.ff{
    font-size: 15px;
    color: white;
    margin-left: 20px;
}
</style>
